import {copyObj} from "@helpers/transform/transform";
import {Border} from "exceljs";
import {mutateColorToExcelJsFormat} from './color'
import {IExportExcelStylesBorders} from "@containers/export/containers/excel/types";

interface IBordersExcelJs {
    top?: Partial<Border>;
    left?: Partial<Border>;
    bottom?: Partial<Border>;
    right?: Partial<Border>;
}

export const mutateBorderToExcelJsFormat = (borders: IExportExcelStylesBorders) => {
    let newBorders: IBordersExcelJs = copyObj(borders) as IBordersExcelJs

    if (borders.bottom) {
        newBorders.bottom = {
            ...borders.bottom,
            color: mutateColorToExcelJsFormat(borders.bottom.color)
        }
    }
    if (borders.top) {
        newBorders.top = {
            ...borders.top,
            color: mutateColorToExcelJsFormat(borders.top.color)
        }
    }
    if (borders.left) {
        newBorders.left = {
            ...borders.left,
            color: mutateColorToExcelJsFormat(borders.left.color)
        }
    }
    if (borders.right) {
        newBorders.right = {
            ...borders.right,
            color: mutateColorToExcelJsFormat(borders.right.color)
        }
    }
    return newBorders;
}